import { useLocation, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from '../../components/ui';
import { images } from '../../config/colors';
import tocBackgroundFallback from '../../assets/tocBackground.jpg';
import styles from './PayVendorPage.module.css';

const tocBackground = images.background || tocBackgroundFallback;

interface LocationState {
  account?: {
    qr_code: string;
    vid?: string;
  };
}

export function PayVendorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = (location.state as LocationState) || {};

  const qrValue = account?.qr_code;

  return (
    <div
      className={styles.background}
      style={{ backgroundImage: `url(${tocBackground})` }}
    >
      <div className={styles.container}>
        <p className={styles.prompt}>Present to cashier for scanning.</p>
        <div className={styles.spacer} />
        <div className={styles.qrContainer}>
          {qrValue ? (
            <QRCodeSVG value={qrValue} size={200} />
          ) : (
            <p>Unable to generate QR code. Please go back and try again.</p>
          )}
        </div>
        <div className={styles.spacer} />
        <Button onClick={() => navigate('/scan-help', { state: { account } })}>
          Trouble Scanning?
        </Button>
      </div>
    </div>
  );
}

export default PayVendorPage;
